module.exports = __webpack_public_path__ + "static/media/sunrise-section-header-logo.6abea3a9.png";